import { computeTrackingPageType } from '@monofront/business/utils';
import { cleanEventSentState } from '@monofront/tracking';
import logger from '@utils/logger';

type GoogleTagManagerEventNames =
  // following events are in order they can made
  // from creating an account to checkout
  | 'pwaInstalled'
  | 'custom.pageView'
  | 'referralSent'
  | 'referralRedeemed'
  | 'accountCreated'
  | 'freeTrialStarted'
  | 'subscribedToNewsletter'
  | 'topCategory'
  | 'filterApplied'
  | 'productAddedToWishlist'
  | 'productAnchorBannerButtonUsed'
  | 'addToCart'
  | 'removeFromCart'
  | 'checkout'
  | 'checkoutError'
  | 'maapPaymentFailure'
  | 'paymentMethodUpdated'
  | 'purchase'
  | 'orderPlaced'
  | 'productReviewed'
  | 'ReorderWidget'
  | 'accountDeletion'
  | 'substitutionPopin'
  // PL
  | 'votedForNextProduct'
  | 'privateLabelSurveySent'
  | 'firstOrderQuestionnaireAnswered'
  // at any moment
  | 'customerType';

/**
 * Names of events that we want to send only once per page
 */
const UNIQUE_EVENTS = [
  'custom.pageView',
  'referralRedeemed',
  'accountCreated',
  'freeTrialStarted',
  'subscribedToNewsletter',
  'checkout',
  'purchase',
  'orderPlaced',
  'accountDeletion',
];

const state = {
  uniqueEventsSent: [] as Array<string>,
};

export const pushDataLayer = (data: Record<string, any>) => {
  if (typeof window != 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
};

export const dataLayerTrackEvent = (
  event: GoogleTagManagerEventNames,
  data: Record<string, any> = {},
) => {
  if (UNIQUE_EVENTS.includes(event) && state.uniqueEventsSent.includes(event)) {
    if (typeof window !== 'undefined' && 'google_tag_manager' in window) {
      const error = new Error('GTM event sent more than once!');

      // warn only if we can clear the dataLayer
      logger.warn(error.message, {
        gaEventType: event,
        error,
        data,
        previous: window.dataLayer
          .slice()
          .reverse()
          .find((e) => e.event === event),
      });
    }
  } else {
    state.uniqueEventsSent.push(event);
  }

  pushDataLayer({
    event,
    ...data,
  });
};

export function gtag() {
  // eslint-disable-next-line prefer-rest-params
  pushDataLayer(arguments);
}

export const fillDataLayer = (data: Record<string, any>, url?: string) => {
  if (url && url.length > 0) {
    data['pageType'] = computeTrackingPageType(url);
  }

  pushDataLayer({ event: 'LFFillDataLayer', ...data });
};

export const cleanGtmState = () => {
  state.uniqueEventsSent = [];
  cleanEventSentState();
};
